module.exports = __webpack_public_path__ + "img/ppob.7597ad90.png";